import m from 'mithril';
import { Store } from '../store';
import { Button } from './Buttons';
import { UserProfileMenu } from './UserProfileMenu';
import { LiveSearch } from './LiveSearch';
import { t, currentLang, setLanguage } from '../i18n';

export const Header: m.Component = {
    view() {
        return m('header', { class: 'fixed top-0 inset-inline-0 z-50 bg-[var(--color-surface)] backdrop-blur-2xl shadow-[var(--shadow-premium)] transition-all duration-300' }, 
            m('div', { class: 'max-w-screen-2xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4 border-b border-[var(--color-border)]/30' }, [
                
                // Left: Logo & Mobile Menu
                m('div', { class: 'flex items-center gap-3 shrink-0' }, [
                    // Hamburger for mobile
                    m('button', {
                        class: '!m-0 !p-1.5 !border-0 !bg-transparent !rounded-md hover:bg-[var(--color-border)]/50 transition-colors cursor-pointer lg:hidden flex items-center justify-center text-[var(--color-text-base)]',
                        onclick: () => { Store.state.isSideMenuOpen = true; m.redraw(); },
                    }, m('iconify-icon', { icon: 'lucide:menu', class: 'text-xl' })),
                    
                    // Logo
                    m('div', { class: 'flex items-center gap-2 cursor-pointer group', onclick: () => m.route.set('/') }, [
                        m('div', { class: 'w-8 h-8 rounded-lg flex items-center justify-center text-white shadow-sm group-hover:scale-105 group-hover:rotate-6 transition-all duration-300', style: 'background: linear-gradient(135deg, var(--color-primary), var(--color-secondary))' }, [
                            m('iconify-icon', { icon: 'lucide:sparkles', class: 'text-lg' })
                        ]),
                        m('span', { class: 'text-lg font-black tracking-tighter hidden sm:block text-[var(--color-text-base)]' }, 'KHALID')
                    ])
                ]),
                
                // Center: Search Bar (Now taking center stage like a native app)
                m(LiveSearch),
                
                // Right: Actions (Language, Cart, Auth)
                m('div', { class: 'flex items-center gap-1.5 sm:gap-2 shrink-0' }, [
                    // Search toggle for mobile only
                    m('button', {
                        class: 'w-8 h-8 flex md:hidden items-center justify-center rounded-full hover:bg-[var(--color-border)]/30 transition-colors cursor-pointer border-0 bg-transparent text-[var(--color-text-base)] opacity-70 hover:opacity-100'
                    }, m('iconify-icon', { icon: 'lucide:search', class: 'text-lg' })),

                    // Language Toggle
                    m('button', { 
                        class: 'w-8 h-8 hidden sm:flex items-center justify-center rounded-full hover:bg-[var(--color-border)]/30 transition-colors cursor-pointer border-0 bg-transparent text-[var(--color-text-base)] opacity-70 hover:opacity-100 font-bold text-xs uppercase',
                        onclick: () => setLanguage(currentLang === 'en' ? 'ar' : 'en')
                    }, currentLang === 'en' ? 'AR' : 'EN'),
                    
                    // Cart Icon Button
                    m('button', { 
                        class: 'relative w-8 h-8 flex items-center justify-center rounded-full hover:bg-[var(--color-border)]/30 transition-colors cursor-pointer border-0 bg-transparent text-[var(--color-text-base)] opacity-70 hover:opacity-100',
                        onclick: () => { Store.state.isCartOpen = true; m.redraw(); } 
                    }, [
                        m('iconify-icon', { icon: 'lucide:shopping-bag', class: 'text-lg' }),
                        Store.state.cart.length > 0 && m('span', { class: 'absolute -top-1 -end-1 bg-[var(--color-primary)] text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full font-black shadow-md border-2 border-[var(--color-surface)] animate-scale-in' }, Store.state.cart.length)
                    ]),
                    
                    // Divider
                    m('div', { class: 'w-px h-5 bg-[var(--color-border)] opacity-50 mx-1 hidden sm:block' }),

                    // Auth Button (Sign In / User Profile)
                    Store.state.user
                        ? m(UserProfileMenu)
                        : m(Button, { 
                            variant: 'primary',
                            size: 'sm',
                            class: 'rounded-full px-4 py-1.5 text-xs font-bold shadow-md hover:shadow-[0_0_15px_var(--color-primary-glow)]',
                            onclick: () => { Store.state.isAuthModalOpen = true; }
                        }, t('nav.signin'))
                ])
            ])
        );
    }
};
